/**
 * Category Tabs with Swiper
 * Initializes Swiper for smooth tab navigation
 */

function initCategoryTabs() {
  if (typeof Swiper === 'undefined') {
    // Retry if Swiper is not loaded yet
    setTimeout(initCategoryTabs, 100);
    return;
  }

  const categoryTabsElements = document.querySelectorAll('.category-tabs');

  categoryTabsElements.forEach(function (element) {
    // Skip if already initialized
    if (element.dataset.swiperInitialized) return;

    const swiperContainer = element.querySelector('.category-tabs__swiper');
    const prevButton = element.querySelector('.category-tabs__prev');
    const nextButton = element.querySelector('.category-tabs__next');

    if (!swiperContainer) return;

    // Get current active link
    const getActiveLink = () => element.querySelector('.category-tabs__link--active');

    // Update button states based on active tab position
    const updateButtonStates = () => {
      const activeLink = getActiveLink();
      if (!activeLink) return;

      const activeItem = activeLink.closest('.category-tabs__nav-item');
      const allItems = element.querySelectorAll('.category-tabs__nav-item');

      // Check if first tab is active
      const isFirstTab = activeItem === allItems[0];
      // Check if last tab is active
      const isLastTab = activeItem === allItems[allItems.length - 1];

      // Disable prev button if first tab is active
      if (prevButton) {
        if (isFirstTab) {
          prevButton.disabled = true;
          prevButton.classList.add('swiper-button-disabled');
        } else {
          prevButton.disabled = false;
          prevButton.classList.remove('swiper-button-disabled');
        }
      }

      // Disable next button if last tab is active
      if (nextButton) {
        if (isLastTab) {
          nextButton.disabled = true;
          nextButton.classList.add('swiper-button-disabled');
        } else {
          nextButton.disabled = false;
          nextButton.classList.remove('swiper-button-disabled');
        }
      }
    };

    // Navigate to previous tab
    if (prevButton) {
      prevButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const activeLink = getActiveLink();
        if (activeLink) {
          const activeItem = activeLink.closest('.category-tabs__nav-item');
          const prevItem = activeItem?.previousElementSibling;
          const prevLink = prevItem?.querySelector('.category-tabs__link');

          if (prevLink && prevLink.href) {
            window.location.href = prevLink.href;
          }
        }
      });
    }

    // Navigate to next tab
    if (nextButton) {
      nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const activeLink = getActiveLink();
        if (activeLink) {
          const activeItem = activeLink.closest('.category-tabs__nav-item');
          const nextItem = activeItem?.nextElementSibling;
          const nextLink = nextItem?.querySelector('.category-tabs__link');

          if (nextLink && nextLink.href) {
            window.location.href = nextLink.href;
          }
        }
      });
    }

    // Initialize Swiper
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: false,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          spaceBetween: 0,
        },
        750: {
          slidesPerView: 'auto',
          spaceBetween: 0,
        },
      },
      on: {
        init: function () {
          // Position active slide at the end of the wrapper
          const activeSlide = swiperContainer.querySelector('.category-tabs__link--active');
          if (activeSlide) {
            const activeSlideIndex = Array.from(this.slides).findIndex((slide) =>
              slide.querySelector('.category-tabs__link--active')
            );
            if (activeSlideIndex !== -1) {
              // Calculate the offset to position active slide at the end
              const wrapperWidth = this.wrapperEl.clientWidth;
              const activeSlideEl = this.slides[activeSlideIndex];
              const slideWidth = activeSlideEl.offsetWidth;

              // Calculate how much we need to scroll to position the slide at the end
              const targetOffset = activeSlideEl.offsetLeft + slideWidth - wrapperWidth;

              if (targetOffset > 0) {
                // Scroll to position active slide at the end
                this.setTranslate(-targetOffset);
                this.updateActiveIndex();
                this.updateSlidesClasses();
              } else {
                // If there's not enough content to scroll, show from start
                this.slideTo(0, 0);
              }
            }
          }
          // Update button states after initialization
          updateButtonStates();
        },
      },
    });

    // Update button states initially
    updateButtonStates();

    // Prevent clicks on active tab
    const allLinks = element.querySelectorAll('.category-tabs__link');
    allLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (link.classList.contains('category-tabs__link--active')) {
          e.preventDefault();
        }
      });
    });

    // Mark as initialized
    element.dataset.swiperInitialized = 'true';
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCategoryTabs);
} else {
  initCategoryTabs();
}
